import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { environment } from 'src/environments/environment';
import { EntitlementsHelperService } from '@ptl/account-management';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ProspectService } from 'src/app/angular-elements/on-exchange-enrollment/services/prospect.service';
import { Prospect } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/prospect.interface';
import { OnExchangeEnrollManagerStateStructure, ON_EXCHANGE_ENROLL_MANAGER_REDUCER_NAME } from 'src/app/angular-elements/on-exchange-enrollment/reducers/enroll-manager.reducer';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { EBillTransferResponseInterface } from 'src/app/shared/interfaces/eBill/transfer.response.interface';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

@Component({
    selector: 'app-ebill-sso',
    templateUrl: './ebill-sso.component.html',
    styleUrls: ['./ebill-sso.component.scss'],
    standalone: false
})

export class EbillSsoComponent implements OnInit {

  @Input() label: string;
  @Input() prospectId: string;

  effectiveDate: string;
  isIndividual: any;
  application: any;
  payload: any;
  formattedProspectArray: Prospect[] = [];


  constructor(
    private httpClient: HTTPWrapperContext,
    private prospectService: ProspectService,
    private commonUtilityService: CommonUtilityService,
    private reducerUtilityService: ReducerUtilityService,
    private entitlementsHelperService: EntitlementsHelperService,
    private eligibilityManagerService: EligibilityManagerService
  ) { }

  ngOnInit(): void {

  }

  async ssoEbill() {

    this.payload = await this.setIndividualEbillPayload();

    const axwayResponse: EBillTransferResponseInterface = await this.axwayEbillCall(this.payload);

    let ebillCookieKey = '';
    let payloadCookie = '';

    for (let i = 0; i < Object.keys(axwayResponse.payload.cookieValues).length; i++) {
      if (Object.keys(axwayResponse.payload.cookieValues)[i].includes('sp_ebill_cookie')) {
        ebillCookieKey = Object.keys(axwayResponse.payload.cookieValues)[i];
        payloadCookie = axwayResponse.payload.cookieValues[ebillCookieKey];
      }
    }

    const domain = window.location.hostname.split('.')[1];
    window.document.cookie = ebillCookieKey + '=' + payloadCookie + ';Domain=.' + domain + '.com;path=/;secure';
    window.open(axwayResponse.payload.redirectURL, 'eBillWindow');

  };

  oauthCallwithAxwayEbill() {

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: environment.external.engen.eBill.url,
      contentType: 'application/x-www-form-urlencoded',
      headers: new HttpHeaders({
        Authorization: 'Basic ' + window.btoa(window.atob(environment.external.engen.eBill.client_id) + ':' + window.atob(environment.external.engen.eBill.client_secret))
      }),
      POST_OR_PUT_PAYLOAD: {}
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.MOCK);
    return this.httpClient.makeRequest(requestConfig);

  }

    axwayEbillCall(payload: any): Promise<EBillTransferResponseInterface> {

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
       url: API_ENDPOINTS.EBILL.SSO_URL,
    // url: environment.external.engen.eBill.ssoUrl,      
      POST_OR_PUT_PAYLOAD: payload
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpClient.makeRequest(requestConfig);

  }

  async setIndividualEbillPayload() {

    let eApp: any = {};
    const payloadState = JSON.parse(JSON.stringify(this.reducerUtilityService.getPayloadStates()));

    let personalInfo: any = {};
    let qhpIdentifier = 'WY1-ON';
    // TODO: Defaulting this to ON exchange for now until we can replace the logic in off-exchange flow to "DRY - DON'T REPEAT YOURSELF" the code
    
    const marketIdentifier = 'ON'; // 'ON' || 'OFF'; // OFF never happens here

    // TODO: move this to AEM config
    // commented out to avoid build errors
    // if (marketIdentifier === 'OFF') {
    //   // TODO: Break this into "build a payload function" for ONX and OFFX eventually
    //   this.isIndividual = true;

    //   eApp = this.reducerUtilityService.getState('EnrollmentApp');
    //   personalInfo = payloadState.individualMarket?.ratingInfo?.subscriber[0];
    //   qhpIdentifier = `${eApp.submittedPlan?.attributes?.BILL_MERCHANT_NAME}-${marketIdentifier}`;
    // }

    if (marketIdentifier === 'ON') {
      await this.eligibilityManagerService.get(this.prospectId);

      // TODO: Break this into "build a payload function" for ONX and OFFX eventually
      const enrollManagerState: OnExchangeEnrollManagerStateStructure = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ENROLL_MANAGER_REDUCER_NAME];

      eApp.appId = enrollManagerState?.application?.FFMPolicyNumber; // Not sure if this is the correct value?
      eApp.transactionId = enrollManagerState?.application?.transactionId;

      eApp.submittedPlan = enrollManagerState?.selectedProduct;

      // const prospects = await this.fetchStatusForProspectONX();

      const eligibilityState: OnExchangeEligibilityStateStructure = this.reducerUtilityService.getComponentStates()[
        ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME
      ];

      const matchedProspects = eligibilityState.prospects.filter(
        p => this.prospectId === p.prospectId
      );

      if (matchedProspects.length > 0) {
        const prospect = matchedProspects[0];

        // remap from ONX to standard values. Required Fields
        personalInfo.firstName = prospect.data.customerData.fullName.firstName;
        personalInfo.lastName = prospect.data.customerData.fullName.lastName;
        personalInfo.addressLine1 = prospect.data.customerData.homeAddress.address;
        personalInfo.addressLine2 = prospect.data.customerData.homeAddress.address2;
        personalInfo.cityName = prospect.data.customerData.homeAddress.city;
        personalInfo.state = prospect.data.customerData.homeAddress.state;
        personalInfo.zipCode = prospect.data.customerData.homeAddress.zipCode;

        personalInfo.ssn = prospect.data.customerData.ssn;

        personalInfo.prospectId = prospect.prospectId;

        this.effectiveDate = prospect.data.effectiveDate;

        // TODO: this needs to be smart enough to switch between ND/WY
        qhpIdentifier = `${environment.initData.brand.ASPID}1-ON`;
      }

    }

    const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');

    let agencyId = '';
    let usrType = 'Member';

    if (this.commonUtilityService.isAgent()) {
      usrType = 'Agent';
      const selectedAgency = await this.entitlementsHelperService.getSelectedAgencyPromise();
      agencyId = selectedAgency.agencyId;
    }

    const payload = {
      baseMessage: {
        headerVersion: '1.0'
      },
      payload: {
        // TODO: submittedPlan is sometimes not avilable and crashing app?
        applicationId: eApp.appId, // Not sure if correct value?
        // Personal Info
        firstName: personalInfo.firstName,
        middleName: '',
        lastName: personalInfo.lastName,
        contactEmailAddress: personalInfo.email,
        // Address
        streetName1: personalInfo.addressLine1 || '', // missing sometimes
        streetName2: personalInfo.addressLine2 || '', // missing sometimes
        cityName: personalInfo.city || personalInfo.cityName || '',
        state: personalInfo.state || '',
        zipCode: personalInfo.zipCode || '',
        region: eApp.submittedPlan?.attributes.PLAN_REGION[0] || '', // may be missing
        // Plan Details
        proposedCoverageEffectiveDate: this.effectiveDate || '',
        totalAmountOwned: eApp.submittedPlan?.price || '', // may be missing
        premiumAmountTotal: eApp.submittedPlan?.price || '', // may be missing
        preferredLanguageCode: 'EN',
        aptcAmount: 0.0, // Optional, zero is fine at the moment.
        // eBill Attributes
        assignedQHPIdentifier: qhpIdentifier || '',
        partnerAssignedConsumerID: personalInfo.ssn || 'set-by-backend',
        paymentTransactionID: eApp.transactionId || 'set-by-backend',
        additionalInformation: '',
        // User Type
        userType: usrType || '',
        agentID: agencyId,
        //
        subscriberIdentifier: '', //subscriber.id,
        transactionID: 'set-by-backend',
        paymentStatus: '',
        prospectID: personalInfo.prospectId || ''
      }
    };

    return payload;

  }


  async fetchStatusForProspectONX() {
    const prospects = await this.prospectService.createProspectIfDoesNotExist();
    return prospects;
  }

}
